import { IAuthorizableGranteePermissions } from '../types/IAuthorizableGranteePermissions';
import { ITypedIds } from '../types/ITypedIds';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetEffectivePermissionsParams {
  userIds: string[];
  authorizables: ITypedIds;
}

export interface IGetEffectivePermissionsResult {
  permissions: IAuthorizableGranteePermissions[];
}

export class GetEffectivePermissionsRequest extends Request<IGetEffectivePermissionsParams, IGetEffectivePermissionsResult> {
  constructor(params: IGetEffectivePermissionsParams) {
    super('getEffectivePermissions', params);
  }
}
